module.exports = __webpack_public_path__ + "img/2-4.f6f170f9.svg";